/** Environment of the product data: the configurator's domainTemplate and environment, and the host of our own oneshot call. */
export enum ProductSource {
  Stage = "stage",
  Prod = "prod",
}

export class WhiteLabelSetupConfiguration {
  constructor(
    public name: string,
    public slug: string,
    public logo: string,
    public showPrices: boolean,
    public pdfTemplate: string,
    public twoStepRegistration: boolean,
    public loginBackground: string,
    public contactPageVisibile: boolean,
    public domain: string,
    public qrCodeTemplateUrl: string,
    public configuratorInactiveChoicesVisible?: boolean,
    /**
     * Undefined means the backend does not expose extra product information for this white label -
     * the Admin section and the product block stay hidden. A boolean is the admin's choice.
     */
    public extraProductInformationEnabled?: boolean,
    /** Undefined until the white label configuration has been loaded (or has failed to load). */
    public productSource?: ProductSource,
  ) {}
}

export function isExtraProductInformationAvailable(configuration: WhiteLabelSetupConfiguration): boolean {
  return typeof configuration?.extraProductInformationEnabled === "boolean";
}

export function isExtraProductInformationEnabled(configuration: WhiteLabelSetupConfiguration): boolean {
  return configuration?.extraProductInformationEnabled === true;
}
